// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .cda-background{background:var(--primary)!important}.logoCajaTop{width:300px;height:auto}table.vgt-table,table.vgt-table .btn{font-size:14px!important}@media only screen and (max-width:1295px){table.vgt-table,table.vgt-table .btn{font-size:12px!important}}@media only screen and (max-width:1008px){table.vgt-table,table.vgt-table .btn{font-size:10px!important}}", ""]);
// Exports
module.exports = exports;
